module.exports = __webpack_public_path__ + "media/images/bg_whitegreen-ea5894b572a54f6236b0c9514bb625c4.png";